export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1758518727613-00192aed759b?auto=format&fit=crop&w=1600&q=80",
  execution: "https://images.pexels.com/photos/1624694/pexels-photo-1624694.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  aiDigital: "https://images.pexels.com/photos/7109243/pexels-photo-7109243.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  tech: "https://images.pexels.com/photos/6930432/pexels-photo-6930432.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  supplyChain: "https://images.pexels.com/photos/4487365/pexels-photo-4487365.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  people: "https://images.unsplash.com/photo-1758518729685-f88df7890776?auto=format&fit=crop&w=1300&q=80",
  career: "https://static.prod-images.emergentagent.com/jobs/d8bd0dce-26f6-4738-a8d7-0dc76374f0b0/images/047d799ef54ae8831617ab10d544bf54c5a9dee6c9d7b8e66b722ca2e6b02c6a.jpeg",
  founder: "https://customer-assets-lxgj4vgw.emergentagent.net/job_transform-strategy-3/artifacts/fp3em8ac_image.png",
  aboutOps: "https://images.pexels.com/photos/30688593/pexels-photo-30688593.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=940",
};

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "AI & Digital", href: "#ai-digital" },
  { label: "People", href: "#people" },
  { label: "Industries", href: "#industries" },
  { label: "Insights", href: "#insights" },
  { label: "Career Coaching", href: "/career" },
  { label: "Contact", href: "#contact" },
];

export const SECTORS = [
  "Public Sector", "Healthcare", "Manufacturing", "Supply Chain & Logistics",
  "Technology", "Professional Services", "Growing SMEs", "Individual Professionals & Leaders",
];

export const EXECUTION = {
  capabilities: [
    { icon: "Globe2", title: "International Trade Operations", desc: "End-to-end management of cross-border trade across goods, services and complete supply chain transactions." },
    { icon: "PackageCheck", title: "Import & Export Management", desc: "Documentation, incoterms, duties and compliant movement of goods into and out of global markets." },
    { icon: "ShieldCheck", title: "Global Logistics & Customs Compliance", desc: "Freight coordination, customs clearance and regulatory compliance across international lanes." },
    { icon: "Truck", title: "Transportation of Goods", desc: "Reliable multimodal transport and delivery, optimised for cost, speed and traceability." },
    { icon: "Building2", title: "Running & Management of SMEs", desc: "Hands-on operation and management of small and medium enterprises, from strategy to daily execution." },
    { icon: "Repeat", title: "End-to-End Supply Chain Transactions", desc: "We support clients across goods and services — from sourcing through delivery and settlement." },
  ],
};

export const SERVICES = [
  {
    icon: "Target",
    title: "Operational Strategy",
    desc: "Align organisational strategy, processes, people and performance to deliver measurable business outcomes.",
    items: ["Business strategy", "Operating model design", "Organisational transformation", "Performance management", "Business process redesign", "KPI development"],
  },
  {
    icon: "Network",
    title: "Supply Chain & Logistics",
    desc: "Help organisations build efficient, resilient and data-driven supply chains.",
    items: ["Supply chain optimisation", "Production & capacity planning", "Inventory optimisation", "S&OP / IBP", "Logistics & warehouse improvement", "Procurement & supply risk"],
  },
  {
    icon: "Gauge",
    title: "Operational Excellence & Lean Six Sigma",
    desc: "Improve productivity, quality, cost and customer outcomes.",
    items: ["Lean Six Sigma", "Continuous improvement", "Value Stream Mapping", "DMAIC & Root Cause Analysis", "Waste reduction & standardisation", "Kaizen"],
  },
  {
    icon: "GraduationCap",
    title: "Career Coaching & Training",
    desc: "Develop people and leaders through practical coaching and hands-on capability training.",
    items: ["Career strategy & transition coaching", "Leadership & executive development", "Lean Six Sigma training", "SAP & planning capability building", "Interview & personal-branding coaching", "Team & workforce upskilling"],
  },
];

export const AI_SERVICES = [
  "AI strategy", "Generative AI adoption", "AI-enabled business processes", "Intelligent automation",
  "Data analytics", "Management dashboards", "Power BI", "ERP transformation",
  "SAP", "Microsoft Dynamics 365", "Workflow automation", "Predictive analytics",
];

export const PEOPLE_ITEMS = [
  "Organisational development", "Industrial & organisational psychology", "Employee engagement",
  "Workplace culture", "Team effectiveness", "Leadership development", "Motivation & performance",
  "Organisational change", "Talent development", "Workforce capability", "Coaching", "Change readiness",
];

export const CAREER_ITEMS = [
  "Career strategy", "Career transition coaching", "CV optimisation", "LinkedIn profile development",
  "Interview preparation", "Executive interview coaching", "Leadership development", "Personal branding",
  "Skills-gap analysis", "Professional development planning", "Career confidence", "Job-search strategy",
];

export const INDUSTRIES = [
  { icon: "Landmark", title: "Public Sector", desc: "Improving efficiency, service delivery, transformation and citizen outcomes." },
  { icon: "HeartPulse", title: "Healthcare", desc: "Optimising processes, workforce systems, operational performance and patient-focused service delivery." },
  { icon: "Factory", title: "Manufacturing", desc: "Improving production planning, operational efficiency, quality, inventory and supply chain performance." },
  { icon: "Truck", title: "Supply Chain & Logistics", desc: "Creating resilient, efficient and digitally enabled supply networks." },
  { icon: "Cpu", title: "Technology & Digital", desc: "Supporting technology adoption, process automation, data utilisation and AI transformation." },
  { icon: "Briefcase", title: "Professional Services & SMEs", desc: "Helping growing organisations strengthen strategy, processes, leadership and performance." },
];

export const APPROACH = [
  { no: "01", title: "Discover", desc: "Understand the organisation, challenges, data, people and strategic objectives." },
  { no: "02", title: "Diagnose", desc: "Identify root causes, performance gaps and opportunities." },
  { no: "03", title: "Strategise", desc: "Develop practical and evidence-based solutions." },
  { no: "04", title: "Implement", desc: "Translate strategy into sustainable operational change." },
  { no: "05", title: "Optimise", desc: "Measure results, build capability and continuously improve." },
];

export const WHY = [
  { icon: "Compass", title: "Strategic + Practical", desc: "We combine strategic thinking with hands-on operational experience." },
  { icon: "BarChart3", title: "Data-Driven", desc: "Recommendations are supported by evidence, analytics and measurable outcomes." },
  { icon: "Cpu", title: "Technology Enabled", desc: "We integrate digital transformation, ERP, analytics, automation and artificial intelligence." },
  { icon: "Users", title: "People Centred", desc: "Successful transformation requires people, leadership and organisational culture." },
  { icon: "Workflow", title: "End-to-End", desc: "From diagnosis and strategy through implementation and continuous improvement." },
  { icon: "Globe", title: "UK & Global Perspective", desc: "International experience combined with local business understanding." },
];

export const STATS = [
  { value: 15, suffix: "+", label: "Years of operational leadership" },
  { value: 8, suffix: "", label: "Core industries served" },
  { value: 40, suffix: "%", label: "Typical efficiency gains" },
  { value: 100, suffix: "%", label: "Client-tailored solutions" },
];

export const TESTIMONIALS = [
  { quote: "Anthony helped us streamline several critical workflows. We saw measurable improvements within weeks.", role: "Operations Director", sector: "Healthcare" },
  { quote: "Our team benefited enormously from Anthony's structured approach. He quickly identified bottlenecks and gave us a clear path forward.", role: "Head of Supply Chain", sector: "Manufacturing" },
  { quote: "Working with OnwardTranscends was a turning point. Anthony brought clarity, calm, and a clear methodology.", role: "Service Manager", sector: "Public Sector" },
  { quote: "Anthony's Lean Six Sigma expertise was evident from day one.", role: "Continuous Improvement Lead", sector: "Logistics" },
  { quote: "We brought Anthony in to support a complex operational review. He is one of the rare consultants who genuinely listens before advising.", role: "Senior Manager", sector: "Private Consultancy" },
];

export const CONTACT = {
  name: "Anthony Onwodi",
  role: "Founder & Principal Consultant",
  phones: ["+44 7305 699094", "+44 7512 081722", "+234 813 130 0026"],
  phone: "+44 7305 699094",
  phoneRaw: "447305699094",
  email: "contact@onwardtranscends.com",
  website: "www.onwardtranscends.com",
  location: "Haverhill, Suffolk, United Kingdom",
  coverage: "United Kingdom & Global",
  linkedin: "https://www.linkedin.com/in/anthonyonwodi?utm_source=share_via&utm_content=profile&utm_medium=member_ios",
};

export const EDUCATION = [
  { degree: "PhD in Engineering", note: "In progress", icon: "GraduationCap" },
  { degree: "MBA", note: "Master of Business Administration", icon: "Award" },
  { degree: "MSc", note: "Master of Science", icon: "Award" },
  { degree: "BEng", note: "Bachelor of Engineering", icon: "Award" },
];

export const TECH_TOOLS = [
  { name: "SAP S/4HANA PP/DS", note: "Production Planning & Detailed Scheduling; BOMs, Routings, PDS, MRP Live" },
  { name: "SAP ERP", note: "Manufacturing, Planning, Procurement, Inventory" },
  { name: "SAP APO", note: "Advanced Planning & Optimisation (PP/DS, SNP, DP)" },
  { name: "Oracle Primavera P6", note: "Advanced scheduling, programme control, critical path, baselines" },
  { name: "Advanced Excel", note: "Power Query, PivotTables, VBA, modelling" },
  { name: "Siemens Opcenter APS (Preactor)", note: "Advanced Planning & Scheduling for manufacturing" },
  { name: "PlanetTogether APS", note: "Capacity planning, finite scheduling, optimisation" },
  { name: "OMP", note: "Supply chain planning, S&OP, demand & inventory optimisation" },
  { name: "Oracle NetSuite", note: "ERP, manufacturing, planning, supply chain modules" },
  { name: "Microsoft Power Platform", note: "Power BI, Power Apps, Power Automate" },
  { name: "Microsoft Project", note: "Scheduling, PMO governance, resource planning" },
  { name: "Dynamics 365", note: "ERP, Project Operations, Supply Chain" },
  { name: "JD Edwards", note: "Manufacturing & supply chain modules" },
  { name: "Tableau", note: "Data visualisation & reporting" },
  { name: "QlikView", note: "BI dashboards & analytics" },
  { name: "Power BI", note: "KPI dashboards, modelling, reporting" },
  { name: "Agile & Scrum", note: "Delivery frameworks & ceremonies" },
  { name: "Integrated Master Scheduling", note: "IMS development & governance" },
  { name: "Critical Path Analysis", note: "Float, dependencies, network logic" },
  { name: "Scenario & Risk Modelling", note: "What-if analysis, Monte Carlo concepts" },
  { name: "Project Controls Reporting", note: "KPI, variance, earned value" },
  { name: "Engineering Change Control", note: "ECN processes & governance" },
  { name: "Lean & Continuous Improvement", note: "CI tools, waste reduction" },
  { name: "Cross-Functional Collaboration", note: "Engineering, supply chain, PMO" },
];

export const CONSULTANCY = {
  partner: "Atheneum Partners Expert",
  intro:
    "As an approved expert with Atheneum Partners, Anthony provides specialist consultations, market insight and due-diligence support to global corporations, consultancies and investment firms — sharing operational, supply-chain and technology expertise on demand.",
  engagements: [
    { title: "Supply Chain Market Study", desc: "Expert input on supply-chain structures, resilience, planning maturity and market dynamics." },
    { title: "Medical Diagnostics Consultancy", desc: "Operational and manufacturing insight across the medical diagnostics and healthcare technology landscape." },
    { title: "Manufacturing & Operations Advisory", desc: "Production planning, capacity, S&OP/IBP and operational-excellence benchmarking." },
    { title: "ERP & Digital Transformation", desc: "SAP, ERP and planning-system adoption, selection and transformation insight." },
    { title: "Procurement & Logistics Insight", desc: "Sourcing strategy, supplier landscapes and logistics-network perspectives." },
    { title: "AI & Automation Adoption", desc: "How organisations responsibly adopt AI, analytics and intelligent automation in operations." },
  ],
};

// Set to a video URL (mp4 or YouTube/Vimeo embed) when ready; empty shows the placeholder.
export const INTRO_VIDEO_URL = "";

export const CASE_STUDIES = [
  {
    company: "Siemens Healthineers",
    sector: "Healthcare Manufacturing",
    role: "Production & Supply Planning Manager",
    period: "Sudbury, Suffolk",
    challenge:
      "Sustain customer service and inventory health across healthcare manufacturing operations while controlling supply risk, shelf-life and obsolescence — and give leadership clear visibility of plant performance and corrective actions.",
    impacts: [
      "Delivered a KPI reporting and PDCA action-cycle project that improved overall planning performance by approximately 12% and lifted on-time service levels from an estimated 88% to 96%",
      "Reduced inventory write-off and obsolescence exposure by approximately 15% — an estimated £150,000 in protected inventory value — through strengthened housekeeping, shelf-life reviews and escalation controls",
      "Led six supply-chain optimisation and process-standardisation projects, generating an estimated £120,000 in annualised efficiency and inventory savings",
      "Managed cross-functional forecast, budget, shelf-life and obsolescence reviews with Operations, Quality, Finance, Procurement and Product Management, covering approximately 1,200 SKUs and £8 million of inventory",
      "Established clearer ownership of supply risks, shortages and recovery actions, improving the quality and speed of operational decision-making",
    ],
    training:
      "Facilitated SAP planning refresher and process-standardisation sessions for approximately 6 planners and supply-chain colleagues, and introduced PDCA and Lean problem-solving techniques to the wider operations team.",
  },
  {
    company: "Essex County Council",
    sector: "Public Sector",
    role: "Customer Continuous Improvement Lead",
    period: "Customer Services & Environment · OSPC Hub",
    challenge:
      "Improve end-to-end customer service delivery across complex, multi-department public-sector operations while strengthening governance, compliance, resident experience and project performance.",
    impacts: [
      "Led end-to-end customer-transformation and service-review projects involving approximately 45 stakeholders across eight service areas, with redesigned processes targeting a 25% reduction in average resolution time",
      "Introduced data-led prioritisation and decision-making frameworks that identified approximately £300,000 of potential cost, capacity and service-risk exposure",
      "Developed continuous-improvement and project-governance frameworks adopted across six multidisciplinary teams, improving performance visibility, accountability and stakeholder alignment",
      "Led the systemic review of the Coroners and Mortuary service, strengthening winter resilience, clarifying operational dependencies and helping prevent formal escalation through the council's Escalation and Decision-Making process",
      "Supported the Complaints and Enquiries automation programme — process mapping, triage design, requirements definition and user-acceptance testing for the Aptean Respond platform",
      "Improved service controls across volunteer management, foster-carer expenses and knowledge-management processes, reducing manual handling and strengthening auditability",
    ],
    training:
      "Delivered Lean Six Sigma and structured problem-solving awareness sessions to approximately 30 employees, and coached six teams in process mapping, root-cause analysis, prioritisation and Agile-style improvement sprints.",
  },
  {
    company: "Johnson Matthey",
    sector: "Advanced Materials & Chemicals",
    role: "Planning Supervisor & SAP Super User",
    period: "Royston",
    challenge:
      "Standardise SAP planning, master data and working practices across global operations; lead a growing planning team; and align weekly production planning with monthly S&OP and business plans during a major global SAP transformation.",
    impacts: [
      "Delivered an estimated £1.2 million reduction in inventory value through Lean inventory reviews, planning-parameter improvements and stock rationalisation, reducing targeted stockholding by approximately 18%",
      "Supported SAP planning integration, implementation and master-data improvement across 43 global sites, including operations in the UK, USA, Mexico and South Africa",
      "Coordinated the review and migration of planning data covering approximately 8,000 materials and SKUs, strengthening data accuracy and MRP reliability",
      "Improved planning-team productivity by approximately 25% through standard operating procedures, common planning routines, clearer escalation paths and performance controls",
      "Recruited, developed and supervised a team of more than 16 planners, including the recruitment and onboarding of 12 planners for the SAP-enabled operating model",
      "Supported weekly planning and monthly S&OP cycles while acting as a key planning representative and super user within the global SAP implementation programme",
    ],
    training:
      "Trained and coached more than 20 planners and key users in SAP PP/MM processes, master-data management, MRP interpretation, inventory control and new planning SOPs.",
  },
  {
    company: "Procter & Gamble (P&G)",
    sector: "FMCG Manufacturing",
    role: "Site Integrated Planner",
    period: "Essex",
    challenge:
      "Deliver reliable ERP-integrated site planning and accurate master data in a fast-moving manufacturing environment, while reducing dead stock and improving coordination among warehouse, production, procurement and supply planning.",
    impacts: [
      "Delivered approximately £250,000 in cost avoidance and inventory recovery through disposal-order control, slow-moving inventory reviews and dead-stock analysis, reducing targeted dead stock by approximately 22%",
      "Supported ERP integration and MRP scheduling improvements that increased inventory-record accuracy to approximately 98%",
      "Improved master-data accuracy by approximately 20% through structured bill-of-material audits, gap analysis and correction of planning parameters",
      "Strengthened integrated scheduling and escalation routines, reducing communication and response delays between warehouse, production and planning by approximately 30%",
      "Improved visibility of material shortages, obsolete inventory and production constraints, enabling earlier intervention and more stable site schedules",
    ],
    training:
      "Trained warehouse, production and planning colleagues in ERP/MRP processes, material-status controls and revised scheduling and escalation procedures.",
  },
  {
    company: "Ball Corporation (formerly Rexam)",
    sector: "Beverage Packaging Manufacturing",
    role: "Supply Chain Management",
    period: "Luton",
    challenge:
      "Coordinate European supply planning across multiple manufacturing plants, suppliers and international markets, maintaining lean inventory while aligning supply, purchasing budgets and strategic metal plans with operational demand.",
    impacts: [
      "Maintained minimum inventory targets across approximately eight European manufacturing plants, releasing or avoiding an estimated £1.5 million in working capital",
      "Led supplier-reconciliation, KPI-review and weekly performance-management activities across approximately 12 strategic suppliers",
      "Produced monthly purchasing budgets, supply plans and strategic metal requirements supporting approximately £25 million in annual purchasing decisions",
      "Improved planning consistency and cross-functional communication through standardised reporting and review routines, increasing planning efficiency by approximately 15%",
      "Strengthened alignment among plants, procurement teams, suppliers and commercial stakeholders, reducing the risk of material shortages and unnecessary stock accumulation",
    ],
    training:
      "Trained approximately 20 plant planners, supply-chain colleagues and supplier-facing users in KPI reporting standards, inventory controls and European supply-planning processes.",
  },
  {
    company: "Shell Petroleum Development Company of Nigeria",
    sector: "Oil & Gas · Offshore Operations",
    role: "Offshore Instrumentation, Planning & Scheduling",
    period: "Nigeria",
    challenge:
      "Keep critical offshore production equipment safe, reliable and compliant while coordinating maintenance, spares and personnel schedules in a demanding offshore environment using structured engineering and project-planning tools.",
    impacts: [
      "Worked with offshore engineers to diagnose and resolve approximately 15–20 mechanical, instrumentation and control-system issues per month, in accordance with operational and safety standards",
      "Participated in structured root-cause investigations contributing to an estimated 15% improvement in equipment reliability and a 20% reduction in recurring faults within targeted equipment categories",
      "Supported preventive and corrective maintenance for approximately 150 critical assets, including valves, piping systems, actuators, HVAC equipment, compressors, pumps and rotating equipment",
      "Maintained engineering and maintenance documentation, improving visibility of equipment history, outstanding work and spares requirements",
      "Planned and scheduled maintenance activities using Oracle Primavera P3, coordinating work rotations, purchasing requirements and spares availability for approximately 40 offshore personnel",
      "Trained and certified as a Helicopter Landing Officer, supporting safe helicopter movements, deck preparation and offshore aviation procedures",
    ],
    training:
      "Provided informal coaching to approximately six junior technicians and engineering colleagues in root-cause analysis, maintenance planning, documentation standards and Primavera schedule updates.",
  },
];

export const CAPABILITIES = [
  { area: "Lean Six Sigma", detail: "Applied DMAIC, process mapping, value-stream analysis, 5 Whys, Fishbone and PDCA across manufacturing and public-sector projects. Delivered awareness and practical improvement coaching to approximately 30–40 employees across multiple teams." },
  { area: "Agile & Iterative Delivery", detail: "Introduced sprint-style working, prioritised improvement backlogs, structured stand-ups and iterative testing across approximately six multidisciplinary teams, involving around 25–30 participants." },
  { area: "Project Management", detail: "Governed improvement and transformation projects using structured initiation, stakeholder analysis, RAID logs, RACI, stage reviews, action tracking and benefits measurement — aligned with PRINCE2, PMI and Lean delivery across more than 15 projects and workstreams." },
  { area: "SAP PP/MM", detail: "Trained and coached more than 20 planners and key users in production planning, MRP, material management, master data, production versions, BOMs, routings, inventory controls and planning SOPs. Supported a global rollout covering 43 sites." },
  { area: "Microsoft Dynamics 365", detail: "Working knowledge of Dynamics 365 supply-chain and operations functionality, supported by self-directed training and process-design experience." },
  { area: "Oracle Primavera P3/P6", detail: "Used Primavera P3 for offshore maintenance, resource and work-rotation scheduling. Provided practical guidance to approximately six technicians, engineers and planning colleagues on schedule updates and work coordination." },
  { area: "KPI & Performance Management", detail: "Designed and embedded KPI dashboards, PDCA reviews, action trackers and governance routines across healthcare, manufacturing and public-sector environments, supporting more than 10 operational and improvement teams." },
  { area: "Team Leadership & Coaching", detail: "Recruited, onboarded, supervised and developed planning teams of up to 16 direct and indirect reports, while coaching a wider network of planners, operational staff and project stakeholders." },
];

export const CLIENTS = [
  { name: "Shell Petroleum SPDC", monogram: "SP" },
  { name: "P&G", monogram: "P&G" },
  { name: "Siemens Healthineers", monogram: "SH" },
  { name: "Johnson Matthey", monogram: "JM" },
  { name: "Ball Corporation", monogram: "B" },
  { name: "Essex County Council", monogram: "EC" },
  { name: "Maple Leaf Foods", monogram: "ML" },
  { name: "Svensk Direktreklam", monogram: "SD" },
];

export const SERVICE_OPTIONS = [
  "Operational Strategy", "Supply Chain & Logistics", "Operational Excellence & Lean Six Sigma",
  "AI, Data & Digital Transformation", "People & Organisational Development", "Career Coaching", "Other",
];
